// Recovered compiled webpack factory 12398. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    return "warn" === e
      ? "warning"
      : ["fatal", "error", "warning", "log", "info", "debug"].includes(e)
        ? e
        : "log";
  }
  r.d(t, { t: () => n });
}
